import canecaImg from "../assets/photos/caneca.jpg";
import cestaImg from "../assets/photos/cesta.jpg";
import azulejoImg from "../assets/photos/azulejo.jpg";
import chaveiroImg from "../assets/photos/chaveiro.jpg";
import kitImg from "../assets/photos/kit.jpg";
import dryfitImg from "../assets/photos/dryfit.jpg";
import memorialImg from "../assets/photos/memorial.jpg";
import cestaVerdeImg from "../assets/photos/cesta-verde.jpg";
import cestaAzulImg from "../assets/photos/cesta-azul.jpg";
import cafeBoxImg from "../assets/photos/cafe-box.jpg";
import camisaPretaImg from "../assets/photos/camisa-preta.jpg";
import camisaJosiImg from "../assets/photos/camisa-josi.jpg";
import canecaStitchImg from "../assets/photos/caneca-stitch.jpg";
import chaveiroRosarioImg from "../assets/photos/chaveiro-rosario.jpg";
import cestaZagoImg from "../assets/photos/cesta-zago.jpg";
import padrinhoImg from "../assets/photos/padrinho.jpg";

export const WA_NUMBER = "5549920004014";

export const waLink = (message) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MSG =
    "Olá! Vim pelo site da Magnus Personalizados e gostaria de solicitar um orçamento.";

export const productMsg = (name) =>
    `Olá! Vim pelo site da Magnus Personalizados e quero personalizar: ${name}. Poderia me enviar os valores?`;

export const CONTACT = {
    whatsappDisplay: "(49) 92000-4014",
    instagram: "@magnus.personalizados",
    instagramUrl: "https://instagram.com/magnus.personalizados",
    email: "magnuspersonalizado@gmail.com",
    cnpj: "67.318.255/0001-78",
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -76, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const NAV_LINKS = [
    { label: "Início", id: "inicio" },
    { label: "Produtos", id: "produtos" },
    { label: "Para Empresas", id: "empresas" },
    { label: "Para Eventos", id: "eventos" },
    { label: "Sobre Nós", id: "sobre" },
    { label: "Como Comprar", id: "como-comprar" },
    { label: "Contato", id: "contato" },
];

export const CATEGORIES = [
    {
        title: "Presentes Personalizados",
        desc: "Canecas, cestas, kits e presentes personalizados para aniversários, casais, familiares, amigos e datas especiais.",
        img: kitImg,
    },
    {
        title: "Canecas Personalizadas",
        desc: "Canecas brancas e coloridas para aniversários, padrinhos, madrinhas, casais, famílias, empresas e diversas ocasiões.",
        img: canecaImg,
    },
    {
        title: "Roupas Personalizadas",
        desc: "Camisetas, camisetas Dry Fit e moletons personalizados.",
        img: dryfitImg,
    },
    {
        title: "Empresas",
        desc: "Produtos personalizados para empresas, equipes, colaboradores, clientes e ações especiais.",
        img: camisaPretaImg,
    },
    {
        title: "Eventos e Formaturas",
        desc: "Produtos personalizados para turmas, formaturas, eventos e comemorações.",
    },
    {
        title: "Lembranças e Personalizados",
        desc: "Azulejos, azulejos memoriais, chaveiros em MDF, garrafas, copos e outros produtos personalizados.",
        img: chaveiroImg,
    },
];

export const PRODUCTS = [
    { name: "Canecas personalizadas", desc: "Canecas brancas e coloridas com nomes, fotos e frases para presentear em qualquer ocasião.", img: canecaImg },
    { name: "Canecas coloridas", desc: "Canecas em cores vivas, personalizadas com a arte que você imaginar.", img: canecaStitchImg },
    { name: "Canecas para padrinhos e madrinhas", desc: "Lembranças especiais para pedir e agradecer aos padrinhos.", img: padrinhoImg },
    { name: "Cestas de presentes", desc: "Cestas montadas com carinho para datas e momentos especiais.", img: cestaVerdeImg },
    { name: "Cestas de café da manhã", desc: "Uma manhã inesquecível para surpreender quem você ama.", img: cafeBoxImg },
    { name: "Kits personalizados", desc: "Kits temáticos com chocolates, ursinhos e produtos combinando.", img: kitImg },
    { name: "Camisetas personalizadas", desc: "Camisetas com a sua arte, para grupos, presentes e datas especiais." },
    { name: "Camisetas Dry Fit", desc: "Leves e confortáveis, perfeitas para equipes e eventos.", img: dryfitImg },
    { name: "Moletons personalizados", desc: "Moletons macios com nomes, frases e estampas exclusivas." },
    { name: "Azulejos personalizados", desc: "Azulejos decorativos que eternizam fotos e recados.", img: azulejoImg },
    { name: "Azulejos memoriais", desc: "Homenagens eternas, produzidas com respeito e cuidado.", img: memorialImg },
    { name: "Chaveiros em MDF", desc: "Chaveiros em MDF cortados e gravados especialmente para você.", img: chaveiroImg },
    { name: "Garrafas personalizadas", desc: "Garrafas com nome e arte para o dia a dia ou para presentear." },
    { name: "Copos personalizados", desc: "Copos estilosos para festas, eventos e uso pessoal." },
    { name: "Produtos personalizados para empresas", desc: "Kits, brindes e produtos para equipes, colaboradores, clientes e ações especiais.", img: camisaJosiImg },
    { name: "Produtos para eventos e formaturas", desc: "Lembranças para turmas, formaturas, eventos e comemorações." },
];

export const GIFT_EXAMPLES = [
    "Canecas", "Cestas", "Kits", "Chocolates", "Ursinhos",
    "Presentes para casal", "Aniversários", "Datas comemorativas",
];

export const COMPANY_EXAMPLES = [
    "Camisetas", "Moletons", "Canecas", "Garrafas",
    "Copos", "Chaveiros", "Brindes personalizados", "Kits corporativos",
];

export const STEPS = [
    {
        num: "01",
        title: "Conte sua ideia",
        desc: "Envie pelo WhatsApp o produto que deseja, quantidade, prazo e sua referência.",
    },
    {
        num: "02",
        title: "Criamos sua personalização",
        desc: "Nossa equipe prepara a arte de acordo com sua ideia.",
    },
    {
        num: "03",
        title: "Você aprova",
        desc: "A personalização é enviada para aprovação antes da produção.",
    },
    {
        num: "04",
        title: "Produzimos seu pedido",
        desc: "Após a aprovação, produzimos seu pedido com cuidado e atenção aos detalhes.",
    },
];
